// https://stackoverflow.com/a/2117523
function uuidv4() {
	return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, (match) => {
		const int = parseInt(match);
		return (int ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (int / 4)))).toString(16);
	});
}

export function generateUniqueUuid(prefix = '') {
	return `${prefix ? `${prefix}-` : ``}${uuidv4()}`;
}
